import type * as CSS from 'csstype';
import type { ResponsiveValue, styleFn } from 'styled-system';

import createCustomParser from '../createCustomParser';
import styledFactory from '../styledFactory';

export interface Props {
  offsetTop?: ResponsiveValue<CSS.Property.Top>;
  offsetBottom?: ResponsiveValue<CSS.Property.Bottom>;
  offsetLeft?: ResponsiveValue<CSS.Property.Left>;
  offsetRight?: ResponsiveValue<CSS.Property.Right>;
  offsetMarginTop?: ResponsiveValue<CSS.Property.MarginTop>;
  offsetMarginBottom?: ResponsiveValue<CSS.Property.MarginBottom>;
  offsetMarginLeft?: ResponsiveValue<CSS.Property.MarginLeft>;
  offsetMarginRight?: ResponsiveValue<CSS.Property.MarginRight>;
}

const systemProp = (name: string, property: string): styleFn =>
  createCustomParser({
    [name]: {
      property,
      scale: 'sizes',
    },
  });

const offsetTop = systemProp('offsetTop', 'top');
const offsetBottom = systemProp('offsetBottom', 'bottom');
const offsetLeft = systemProp('offsetLeft', 'left');
const offsetRight = systemProp('offsetRight', 'right');

const offsetMarginTop = systemProp('offsetMarginTop', 'marginTop');
const offsetMarginBottom = systemProp('offsetMarginBottom', 'marginBottom');
const offsetMarginLeft = systemProp('offsetMarginLeft', 'marginLeft');
const offsetMarginRight = systemProp('offsetMarginRight', 'marginRight');

/**
 * Box with capabilites to set offset margin or position on the sizes scale.
 */
const OffsetBox = styledFactory<Props, 'div'>('div', 'OffsetBox', undefined, [
  offsetTop,
  offsetBottom,
  offsetLeft,
  offsetRight,
  offsetMarginTop,
  offsetMarginBottom,
  offsetMarginLeft,
  offsetMarginRight,
]);

export default OffsetBox;
